<template lang="pug">
    div
        v-card.mb-4(
            elevation="4"
            shaped
            style="height: 150px !important;"
        )
            v-toolbar(dense)
                v-icon.mr-2 mdi-office-building-outline
                v-toolbar-title Incoming
            
            v-card-text.pa-0
                v-simple-table(style="width: 100%;" v-if="validDayDashboardSummary")
                    template(v-slot:default)
                        tbody
                            tr
                                td.no-wrap.sm-width.xs-height.task-border-right
                                    .d-flex.align-center
                                        .ml-2.mr-1.text-left
                                            .text-subtitle-1.font-weight-medium.volie-color-blue Messages
                                            .text-h4.font-weight-bold {{ currentDayDashboardSummary.message_incoming_message_count | number }}
                                        v-spacer
                                        .ml-auto
                                            v-icon.volie-color-blue(size="45")
                                                | mdi-message-plus

                                td.no-wrap.sm-width.xs-height.task-border-right
                                    .d-flex.align-center
                                        .ml-2.mr-1.text-left
                                            .text-subtitle-1.font-weight-medium.volie-color-blue Opt Ins
                                            .text-h4.font-weight-bold {{ currentDayDashboardSummary.message_incoming_message_opt_in_count | number }}
                                        v-spacer
                                        .ml-auto
                                            v-icon.volie-color-blue(size="45")
                                                | mdi-cellphone-check

                                td.no-wrap.sm-width.xs-height.task-border-right
                                    .d-flex.align-center
                                        .ml-2.mr-1.text-left
                                            .text-subtitle-1.font-weight-medium.volie-color-blue Opt Outs
                                            .text-h4.font-weight-bold {{ currentDayDashboardSummary.message_incoming_message_opt_out_count | number }}
                                        v-spacer
                                        .ml-auto
                                            v-icon.volie-color-blue(size="45")
                                                | mdi-cellphone-remove

        v-card.mt-4(
            elevation="4"
            shaped
            style="height: 334px !important;"
        )
            v-toolbar(dense)
                v-icon.mr-2 mdi-account
                v-toolbar-title Response
            
            v-card-text
                v-row
                    v-col(cols="6")
                        v-list.py-0(
                            two-line
                        )
                            v-list-item
                                v-list-item-content
                                    v-list-item-title
                                        strong {{ currentDayDashboardSummary.message_outgoing_message_count | number }}
                                    v-list-item-subtitle Messages Sent

                            v-list-item
                                v-list-item-content
                                    v-list-item-title
                                        strong {{ currentDayDashboardSummary.message_responded_message_count | number }}
                                    v-list-item-subtitle Waiting Responded To

                            v-list-item
                                v-list-item-content
                                    v-list-item-title
                                        strong {{ currentDayDashboardSummary.message_outgoing_follow_up_message_count | number }}
                                    v-list-item-subtitle Follow Ups Sent

                            v-list-item
                                v-list-item-content
                                    v-list-item-title
                                        strong {{ currentDayDashboardSummary.message_outgoing_campaign_customer_message_count | number }}
                                    v-list-item-subtitle Deployment Messages

                    v-col(cols="6")
                        v-list.py-0(
                            two-line
                        )
                            v-list-item
                                v-list-item-content
                                    v-list-item-title
                                        strong {{ deliveryRate }}%
                                    v-list-item-subtitle Delivery %

                            v-list-item
                                v-list-item-content
                                    v-list-item-title
                                        strong {{ (currentDayDashboardSummary.message_responded_average_wait_duration || 0) | secondsToFullWords }}
                                    v-list-item-subtitle Average Response Time

                            v-list-item
                                v-list-item-content
                                    v-list-item-title
                                        strong {{ currentDayDashboardSummary.message_outgoing_follow_up_message_replies_count | number }} ({{ followUpReplyRate }}%)
                                    v-list-item-subtitle Follow Up Replies

                            v-list-item
                                v-list-item-content
                                    v-list-item-title
                                        strong {{ currentDayDashboardSummary.sms_message_appointment_new_count | number }}
                                    v-list-item-subtitle New Appointments

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    export default Vue.extend({
        data() {
            return {
            }
        },
        methods: {
        },
        computed: {
            deliveryRate() {

                // Init
                let rate = "0.0";
                if (!this.validDayDashboardSummary) {
                    return rate;
                }

                // Ensure valid
                if (this.currentDayDashboardSummary.message_outgoing_message_count > 0 && this.currentDayDashboardSummary.message_outgoing_message_delivered_count > 0) {
                    rate = ((this.currentDayDashboardSummary.message_outgoing_message_delivered_count * 1.0) / (this.currentDayDashboardSummary.message_outgoing_message_count * 1.0) * 100.0).toFixed(2);
                }

                return rate;
            },
            followUpReplyRate() {

                // Init
                let rate = "0.0";
                if (!this.validDayDashboardSummary) {
                    return rate;
                }

                // Ensure valid
                if (this.currentDayDashboardSummary.message_outgoing_follow_up_message_count > 0 && this.currentDayDashboardSummary.message_outgoing_follow_up_message_replies_count > 0) {
                    rate = ((this.currentDayDashboardSummary.message_outgoing_follow_up_message_replies_count * 1.0) / (this.currentDayDashboardSummary.message_outgoing_follow_up_message_count * 1.0) * 100.0).toFixed(2);
                }

                return rate;
            },
            validDayDashboardSummary() {
                return this.currentDayDashboardSummary?.id > 0;
            },
        },
        components: {
        },
        props: {
            currentDayDashboardSummary: Object,
        },
        watch: {
        },
        destroyed() {
        },
        created() {
        },
    });
</script>

<style lang="scss" scoped>
</style>